var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMejorasbio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.667 917C105.667 916.267 105.067 915.667 104.333 915.667 104.067 915.667 103.833 915.733 103.633 915.867L97.9333 919.133C98 919.5 98 919.867 97.9333 920.267 97.6667 921.5 96.5 922.333 95.2333 922.333L89.3333 922.333 89.3333 921 95.3333 921C96.0667 921 96.6667 920.4 96.6667 919.667 96.6667 918.933 96.0667 918.333 95.3333 918.333 95.3333 918.333 87.4 918.333 87.3333 918.333 86.7667 918.333 86.2333 918.5 85.7667 918.767L76.3333 923.333 81 928C83.1667 925.833 85.9667 925 89 925L95.2333 925C95.5333 925 95.8 924.9 96.0333 924.733L105.2 918.033C105.467 917.767 105.667 917.4 105.667 917Z",
    stroke: "#70AD47",
    strokeWidth: 0.333333,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.033 906.067C101.033 906.067 96.9 905.533 94.7 907.733 93.1 909.333 92.9333 911.9 92.9667 913.233 92.2667 913.733 91.6667 914.467 91.2667 915.333 91.1667 915.2 91.1 915.067 91 914.933 91.0333 913.833 90.8667 911.733 89.5667 910.433 87.7333 908.6 84.3333 909.067 84.3333 909.067 84.3333 909.067 83.9 912.467 85.7 914.3 86.8667 915.467 88.7333 915.7 89.8667 915.733 90.2 916.1 90.4333 916.633 90.6 917.1 90.6333 917.2 90.6667 917.433 90.6667 917.733L92.0333 917.733C92.0667 917.033 92.1667 916.633 92.4333 916.067 92.7667 915.267 93.3333 914.6 94 914.2 95.3667 914.233 97.8333 914 99.3667 912.467 101.567 910.2 101.033 906.067 101.033 906.067Z",
    stroke: "#70AD47",
    strokeWidth: 0.333333,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMejorasbio);
export default __webpack_public_path__ + "static/media/mejorasbio.358e32920d099283da099495dfcd114a.svg";
export { ForwardRef as ReactComponent };